var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5044 1.21924H6.49353C3.58092 1.21924 1.21875 3.58141 1.21875 6.49402V35.5049C1.21875 38.4183 3.58092 40.7805 6.49434 40.7805H35.5044C38.4179 40.7805 40.78 38.4183 40.78 35.5049V6.49402C40.78 3.5806 38.4187 1.21924 35.5052 1.21924H35.5044Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.505 42H6.49495C2.91342 42 0 39.0866 0 35.505V6.49415C0 2.91342 2.91342 0 6.49415 0H35.505C39.0858 0 41.9992 2.91342 41.9992 6.49415V35.505C41.9992 39.0866 39.0858 42 35.5042 42H35.505ZM6.49415 2.43873C4.2577 2.43873 2.43873 4.2577 2.43873 6.49415V35.505C2.43873 37.7415 4.25851 39.5605 6.49415 39.5605H35.5042C37.7407 39.5605 39.5597 37.7407 39.5597 35.505V6.49415C39.5597 4.2577 37.7407 2.43873 35.5042 2.43873H6.49415Z",
    fill: "#67B3FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5044 1.21924H6.49353C3.58092 1.21924 1.21875 3.58141 1.21875 6.49402V35.5049C1.21875 38.4183 3.58092 40.7805 6.49434 40.7805H35.5044C38.4179 40.7805 40.78 38.4183 40.78 35.5049V6.49402C40.78 3.5806 38.4187 1.21924 35.5052 1.21924H35.5044Z",
    fill: "#3B82F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8926 9.35581C18.8926 9.056 18.9458 8.78199 19.053 8.53215C19.1601 8.28312 19.31 8.06149 19.5027 7.86887C19.6953 7.67626 19.9161 7.52636 20.1659 7.41917C20.415 7.31198 20.6825 7.25879 20.9686 7.25879C21.5674 7.25879 22.0736 7.45866 22.4878 7.85759C22.9013 8.25733 23.1084 8.7562 23.1084 9.355C23.1084 9.6403 23.0512 9.90787 22.9375 10.1577C22.8231 10.4075 22.67 10.6284 22.4773 10.821C22.2847 11.0136 22.0599 11.1667 21.8036 11.2812C21.5465 11.3956 21.2684 11.452 20.9694 11.452C20.6704 11.452 20.4166 11.3948 20.1667 11.2812C19.9169 11.1667 19.6961 11.0136 19.5035 10.821C19.3109 10.6284 19.161 10.4075 19.0538 10.1577C18.9466 9.90867 18.8934 9.6411 18.8934 9.355L18.8926 9.35581ZM22.8295 31.9943C22.8295 32.2513 22.7828 32.4899 22.6901 32.7107C22.5974 32.9324 22.4685 33.125 22.3049 33.2886C22.1413 33.4522 21.9478 33.5851 21.727 33.6843C21.5054 33.7842 21.2668 33.8342 21.0106 33.8342C20.7543 33.8342 20.5149 33.7842 20.2941 33.6843C20.0725 33.5843 19.8766 33.4522 19.7058 33.2886C19.5349 33.125 19.3987 32.9324 19.2996 32.7107C19.1996 32.4899 19.1497 32.2505 19.1497 31.9943V15.7968C19.1497 15.2834 19.3318 14.845 19.6953 14.4807C20.0588 14.1164 20.5044 13.9351 21.0323 13.9351C21.5602 13.9351 21.9736 14.1172 22.3161 14.4807C22.6587 14.8442 22.8295 15.2834 22.8295 15.7968V31.9943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3_54",
    x: 1.21875,
    y: 1.21924,
    width: 39.5605,
    height: 39.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_54",
    x: 17.6031,
    y: 6.85583,
    width: 6.14906,
    height: 28.5094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.32237,
    dy: 0.564148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.483555
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_54"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_54",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf75023b1cbbf22e0c69baeaf4632fe8.svg";
export { ForwardRef as ReactComponent };